'use client';

import RankingList from './RankingList';
import Tooltip from './Tooltip';

export default function RankingSection() {
  return (
    <div className="px-5 pt-10">
      <div className="relative">
        <h2 className="relative typo-heading-3 text-center text-g-00">데일리 랭킹</h2>
        <Tooltip />
      </div>

      <RankingList />
    </div>
  );
}
